<template>
  <v-row>
    <v-col cols="12" class="pb-0">
      <h4 class="secondary--text">
        {{ $t('fleet_management.agents.time_limit.labels.title') }}
      </h4>
    </v-col>
    <v-col>
      <v-row>
        <v-col md="3">
          <v-select
            v-model="timeObj.days"
            :label="$t('fleet_management.agents.time_limit.labels.days')"
            item-value="value"
            required
            :readonly="!editMode || conditionSpeedSelected"
            hide-details="auto"
            item-text="time"
            return-object
            :items="days"
            :rules="timeRules"
            @change="timeEmit"
            color="tertiary"
            append-icon="mdi-alarm"
          ></v-select>
        </v-col>
        <v-col md="3">
          <v-select
            :label="$t('fleet_management.agents.time_limit.labels.hours')"
            return-object
            v-model="timeObj.hours"
            item-value="value"
            required
            :readonly="!editMode || conditionSpeedSelected"
            hide-details="auto"
            item-text="time"
            :items="hours"
            :rules="timeRules"
            @change="timeEmit"
            color="tertiary"
            append-icon="mdi-alarm"
          ></v-select>
        </v-col>
        <v-col md="3">
          <v-select
            :label="$t('fleet_management.agents.time_limit.labels.minutes')"
            return-object
            v-model="timeObj.minutes"
            item-value="value"
            required
            :readonly="!editMode"
            hide-details="auto"
            item-text="time"
            :items="minutes"
            :rules="timeRules"
            @change="timeEmit"
            color="tertiary"
            append-icon="mdi-alarm"
          ></v-select>
        </v-col>
        <v-col md="3">
          <v-select
            :label="$t('fleet_management.agents.time_limit.labels.seconds')"
            return-object
            v-model="timeObj.seconds"
            item-value="value"
            required
            :readonly="!editMode"
            hide-details="auto"
            item-text="time"
            :items="seconds"
            :rules="timeRules"
            @change="timeEmit"
            color="tertiary"
            append-icon="mdi-alarm"
          ></v-select>
        </v-col>
      </v-row>
      <v-row v-if="conditionSpeedSelected">
        <v-col class="warning--text">
          {{
            $t(
              'fleet_management.agents.time_limit.labels.max_window_spped_limit'
            )
          }}
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'Time Limit',
  props: {
    editMode: {
      type: Boolean,
      default: false
    },
    dataProp: {
      type: Number,
      default: 0
    },
    conditions: {
      type: Array
    }
  },
  components: {},
  data() {
    return {
      timeRules: [v => v !== '' || 'Campo Obligatorio'],
      days: [],
      hours: [],
      minutes: [],
      seconds: []
    }
  },
  methods: {
    timeEmit() {
      //Con el condicional evitamos se pueda seleccionar una tolerancia de 20min 30seg para la condición
      //exceso de velocidad
      if (this.conditionSpeedSelected && this.timeObj.minutes.time == 20) {
        this.timeObj.seconds = {
          time: 0,
          value: 0
        }
        this.seconds = this._setSeconds(1)
      } else this.seconds = this._setSeconds()

      const sum =
        this.timeObj.days.value +
        this.timeObj.hours.value +
        this.timeObj.minutes.value +
        this.timeObj.seconds.value

      this.$emit('timeEmit', sum)
    },
    parseTime(window) {
      const days = Math.floor(window / (3600 * 24))
      const hours = Math.floor((window % (3600 * 24)) / 3600)
      const minutes = Math.floor((window % 3600) / 60)
      const seconds = Math.floor(window % 60)

      return {
        days: {
          time: days,
          value: days * 24 * 3600
        },
        hours: {
          time: hours,
          value: hours * 3600
        },
        minutes: {
          time: minutes,
          value: minutes * 60
        },
        seconds: {
          time: seconds,
          value: seconds
        }
      }
    },
    _setDays() {
      const allDays = []
      for (let index = 0; index < 8; index++) {
        const time = {
          time: index,
          value: index * 24 * 3600
        }
        allDays.push(time)
      }
      return allDays
    },
    _setHours() {
      const allHours = []
      for (let index = 0; index < 24; index++) {
        const time = {
          time: `${index}`,
          value: index * 3600
        }
        allHours.push(time)
      }
      return allHours
    },
    _setMinutes(max = 60) {
      const allMinutes = []
      for (let index = 0; index < max; index++) {
        const time = {
          time: `${index}`,
          value: index * 60
        }
        allMinutes.push(time)
      }
      return allMinutes
    },
    _setSeconds(max = 2) {
      const allSeconds = []
      for (let index = 0; index < max; index++) {
        const time = {
          time: index == 0 ? `${index}` : '30',
          value: index == 0 ? index : 30
        }
        allSeconds.push(time)
      }

      return allSeconds
    },
    _resetWindow() {
      //Volver a inicializar los valores solo es necesario durante la pantalla de creación de agente
      if (this.$route.name == 'agent-create') {
        Object.assign(this.timeObj, {
          days: { time: 0, value: 0 },
          hours: { time: 0, value: 0 },
          minutes: { time: 0, value: 0 },
          seconds: { time: 0, value: 0 }
        })
      }

      this.minutes = this._setMinutes(21)
    },
    setAllValues() {
      this.days = this._setDays()
      this.hours = this._setHours()
      this.minutes = this._setMinutes()
      this.seconds = this._setSeconds()
    }
  },

  computed: {
    conditionSpeedSelected() {
      //Reactivo al cambio de condiciones para modificar los controles de tiempo y establecer el tope de minutos
      //si la condición es de exceso de velocidad
      let found
      if (typeof this.conditions !== 'undefined') {
        found = this.conditions.find(
          element => element == 'mrn:agent_condition:speed_limit'
        )
        if (typeof found !== 'undefined') {
          this._resetWindow()
        } else this.setAllValues() //Si la condición cambió a solo geofensa se reestablecen los valores iniciales
      }
      return typeof found !== 'undefined' ? true : false
    },
    timeObj() {
      let obj
      if (this.dataProp > 0) obj = this.parseTime(this.dataProp)
      if (typeof obj !== 'undefined') {
        return obj
      } else {
        return {
          days: { time: 0, value: 0 },
          hours: { time: 0, value: 0 },
          minutes: { time: 0, value: 0 },
          seconds: { time: 0, value: 0 }
        }
      }
    }
  },
  created() {
    //Inicializamos los valores de tiempo
    this.setAllValues()
  }
}
</script>

<style lang="scss" scoped></style>
